import { Box } from '@mui/material';
import { Suspense } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const ConditionalRoutes = ({ isAllowed = true, redirectTo = {} }) => {
  return isAllowed ? (
    <Box sx={{ minHeight: '250px', width: '100%' }}>
      <Suspense>
        <Outlet />
      </Suspense>
    </Box>
  ) : (
    <Navigate to={redirectTo} replace />
  );
};

export default ConditionalRoutes;
